import styled from 'styled-components';
import { Drawer as DrawerBase } from '@mui/material';
import { ReactComponent as CloseIcon } from '../../assets/close-2.svg';
import { HEADER_HEIGHT } from '../../constants';
import { FlexColumn, FlexSpace } from '../Flex';

export const DrawerStyled = styled(DrawerBase).attrs({
  anchor: 'right',
  hideBackdrop: true,
  ModalProps: {
    disableEnforceFocus: true,
    disableAutoFocus: true,
    disableRestoreFocus: true,
    sx: {
      pointerEvents: 'none',
      '& .MuiDialog-container': {
        pointerEvents: 'none',
      },
      '> .MuiPaper-root': {
        height: `calc(100% - ${HEADER_HEIGHT}px)`,
        marginTop: `${HEADER_HEIGHT}px`,
        pointerEvents: 'auto',
      },
    },
  },
  PaperProps: { elevation: 0, style: { backgroundColor: 'transparent' } },
})<{ $rightOffset?: number }>`
  &.MuiDrawer-root {
    z-index: ${({ theme }) => theme.zIndex.drawer + 1};
  }

  > .MuiPaper-root {
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
    ${({ $rightOffset }) =>
      $rightOffset && `clip-path: inset(-8px 0 -8px -8px);`}
    border-radius: 8px 0 0 8px;
    right: ${({ $rightOffset }) => $rightOffset || 0}px;
  }
`;

export const Wrapper = styled(FlexColumn)<{
  $width: number;
  $rightOffset?: number;
}>`
  background-color: ${({ theme }) => theme.palette.common.white};
  height: 100%;
  width: ${({ $width }) => $width}px;
  border-radius: 8px 0 0 8px;
  border: 1px solid ${({ theme }) => theme.palette.common.gray16};
  border-top: none;
  border-right: ${({ $rightOffset }) => ($rightOffset ? 'none' : undefined)};
  overflow: hidden;
`;

export const Header = styled(FlexSpace)`
  padding: 16px 24px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.common.gray16};
  height: 57px;
`;

export const Footer = styled(FlexSpace)`
  justify-content: flex-end;
  padding: 16px 24px;
  border-top: 1px solid ${({ theme }) => theme.palette.common.gray16};
`;

export const Content = styled(FlexColumn)<{ $noPadding?: boolean }>`
  height: 100%;
  padding: ${({ $noPadding }) => ($noPadding ? 0 : '24px')};
  overflow: auto;
`;

export const CloseIconStyled = styled(CloseIcon)`
  width: 14px;
  height: 14px;
  path {
    fill: ${({ theme }) => theme.palette.common.black};
  }
`;
